import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import { Provider, useDispatch } from "react-redux";

import { LoadNormalizedCargos } from "../../../../../../../domain/usecases/load-normalized-cargos";
import { NormalizedCargo } from "../../../../../../../domain/models/cargo-model";
import { checkShipmentStore } from "../../store";
import DrawerAppBar from "../../../../../../components/mobile/Navbar";
import { useErrorHandler } from "../../../../../hooks";
import { CargoCard } from "../CargoCard";

type Props = {
  loadCargos: LoadNormalizedCargos;
};

export const Main = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cargos, setCargos] = useState<NormalizedCargo[]>([]);

  const handleError = useErrorHandler((error) => {
    alert(error);
  });

  React.useEffect(() => {
    async function fetch() {
      const warehouseString = localStorage.getItem("currentWarehouse");
      const warehouse = warehouseString
        ? (JSON.parse(warehouseString) as {
            id: number;
            name: string;
          } | null)
        : undefined;
      try {
        const data = await props.loadCargos.load(warehouse!.id, {
          date: new Date(Date.now()).toDateString(),
        });

        var initialDate = new Date();
        let endDate = new Date();
        initialDate.setDate(initialDate.getDate() - 2);
        endDate.setDate(endDate.getDate() - 1);
        const delayedCargos = await props.loadCargos.load(warehouse!.id, {
          status: ["NOT_CHECKED", "PENDING"],
          dateRange: [
            initialDate.toISOString().slice(0, 10),
            endDate.toISOString().slice(0, 10),
          ],
        });
        setCargos([...delayedCargos, ...data]);
      } catch (error) {
        handleError(error as Error);
      }
    }

    fetch();
  }, []);

  cargos.forEach((obj) => {
    let separated = true;
    obj.cargoItems.forEach((item) => {
      item.inventoryReservations?.forEach((reservation) => {
        if (reservation.status !== "SEPARATED") {
          separated = false;
        }
      });
    });
  });

  return (
    <Provider store={checkShipmentStore}>
      <DrawerAppBar
        title="Conferir Saídas"
        onBack={() => {
          navigate("/mobile/check");
        }}
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        {cargos.map((cargo) => {
          return <CargoCard cargo={cargo} key={cargo.reference} />;
        })}
      </Stack>
    </Provider>
  );
};
